<template>
    <div class="main">
        <van-form style="padding: 10px;" @submit="onSubmit">
            <template v-if="type === 'phone'">
                <van-field v-model="formData.Name" label="姓名" readonly/>
                <van-field v-model="formData.Phone" label="电话" placeholder="请填写电话号码" clearable type="tel" :rules="[{ required: true }]"/>
            </template>
            <template v-else-if="type === 'car'">
                <van-field v-model="formData.CarBrand" label="品牌" placeholder="请输入车辆品牌 例如：丰田" clearable :rules="[{ required: true }]"/>
                <van-field
                    v-model="formData.CarName"
                    label="车型"
                    placeholder="请输入车辆系列 例如：卡罗拉"
                    clearable
                    :rules="[{ required: true }]"
                />
                <van-field
                    v-model="formData.CarNum"
                    label="车牌号码"
                    placeholder="请填写车牌号码"
                    clearable
                    :rules="[{ pattern, message: '请输入正确车牌号' }]"
                />
                <div style="display:flex;justify-content: space-between;font-size: 14px;">
                    <div style="background-color:#F5F5F5;padding: 12px 0 0 12px;border-radius: 4px;width: 45%;">
                    <div>车辆颜色</div>
                    <van-field v-model="formData.CarColor" placeholder="请填写车辆颜色" clearable :rules="[{ required: true }]" style="padding:0;width: 90%;"/>
                    </div>
                    <div span="12" style="background-color:#F5F5F5;padding: 12px 0 0 12px;border-radius: 4px;width: 45%;">
                    <div>座位</div>
                    <van-field name="CarSeat" style="padding:0;width: 90%;">
                        <template #input>
                        <van-stepper v-model="formData.CarSeat" theme="round" button-size="22"/>
                        </template>
                    </van-field>
                    </div>
                </div>                
            </template>
            <template v-else>
                <van-cell is-link @click="showRoute = true">
                    <template #title>
                        <van-image width="20" height="20" :src="require('../../assets/img1.svg')" style="top:5px;"/>
                        {{routeTitle}}
                    </template>
                </van-cell>
                <!-- <van-field v-model="formData.Origin" label="出发地" placeholder="请填写出发地" clearable :rules="[{ required: true }]"/> -->
                <van-field v-model="routeData.Destination" label="目的地" placeholder="请填写目的地" clearable :rules="[{ required: true }]"/>
                <van-field v-model="routeData.Way" label="途径地" placeholder="多个途径地用空格键分开" clearable :rules="[{ required: true }]"/>
                <van-field
                    v-model="routeData.DepartTime"
                    label="时间"
                    placeholder="请选择时间"
                    readonly
                    clearable
                    right-icon="arrow"
                    @click="showPicker = true"
                    :rules="[{ required: true }]"/>
                <van-field v-model="routeData.Remark" label="备注" placeholder="(选填)填写备注" clearable />                
            </template>

            <div style="margin: 20px 0 40px 0;">
                <van-button round block color="#FEB013" native-type="submit">提交保存</van-button>
            </div>
        </van-form>

        <van-popup v-model="showPicker" position="bottom">
            <van-datetime-picker
                type="time"
                :min-hour="minDate"
                @confirm="onConfirmTime"
                @cancel="showPicker = false"
            />
        </van-popup>

        <van-popup v-model="showRoute" round position="bottom">
            <van-radio-group v-model="Radio" style="margin-top: 20px;">
                <div
                    v-for="(item, key) in RList" :key="key"
                    class="radioBox"
                    @click="checkRadio(item)"
                    :style="item.name === Radio ?'background-color: rgba(254, 176, 19, 0.1);':'background-color: #F5F5F5;'">
                    <div style="display: flex;align-items: center;">
                        <van-image width="20" height="20" :src="require('../../assets/img1.svg')"/>
                        <div>路线{{item.name}}:{{item.detail}}</div>            
                    </div>
                    <van-radio :name="item.name" checked-color="#FEB013"/>
                </div>
            </van-radio-group>
            <div style="margin: 20px 20px 40px 20px;">
                <van-button round block color="#FEB013" @click="showRoute = false">保存变更</van-button>
            </div>
        </van-popup>
    </div>
</template>
<script>
export default {
    data() {
        return {
            formData: {},
            routeData: {},
            showPicker: false,
            routeTitle: '请设置路线',
            Radio: '',
            showRoute: false,
            minDate: new Date().getHours(),
            type: '',
            pattern: /^([京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领A-Z]{1}[a-zA-Z](([DF]((?![IO])[a-zA-Z0-9](?![IO]))[0-9]{4})|([0-9]{5}[DF]))|[京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领A-Z]{1}[A-Z]{1}[A-Z0-9]{4}[A-Z0-9挂学警港澳]{1})$/
        }
    },
    mounted() {
        // const test = {"errno":0,"data":{"area":"健树","errcode":0,"errmsg":"ok","userid":"201755100","name":"吴昌悦","department":[2267],"position":"软件开发工程师","mobile":"15812615614","gender":"1","email":"wuchangyue@jianlianmed.com","avatar":"http://wework.qpic.cn/wwhead/duc2TvpEgSTPk74IwG7Bs6QbDoJ0d3L4YVkyYficZxxcflGOZ1LUI81OkNwXIicNlbdduibhLKxSGc/0","status":1,"isleader":0,"extattr":{"attrs":[{"name":"英文名","value":"","type":0,"text":{"value":""}},{"name":"工号","value":"2017551","type":0,"text":{"value":"2017551"}},{"name":"身份证","value":"","type":0,"text":{"value":""}}]},"english_name":"","telephone":"020-88985632","enable":1,"hide_mobile":0,"order":[0],"external_profile":{"external_attr":[],"external_corp_name":""},"main_department":2267,"qr_code":"https://open.work.weixin.qq.com/wwopen/userQRCode?vcode=vc5b6c10860443246c","alias":"","is_leader_in_dept":[0],"address":"","thumb_avatar":"http://wework.qpic.cn/wwhead/duc2TvpEgSTPk74IwG7Bs6QbDoJ0d3L4YVkyYficZxxcflGOZ1LUI81OkNwXIicNlbdduibhLKxSGc/100","direct_leader":[],"openid":"ozAQBt9Jauj5fMYuM9Q0bNmhaAo8","access_token":"hER4OJaZReJSc_9Mi6NCJTXyliK2QkEDuj0ruK4CsiFGKySTq81qK6AsR7GqX6bROcq28TctrjQqtXheO0mKenvkX6pu6kkuP9cSO51qDnBHwnOThgl4thnSeAFw_PlA0aUdAX3tE5yPHs3IIgOwB4bEc6yFKchMe7tjjaACla90dBlIe8j8JuSB-SOLpoWVXMI36ulQW7uRs6VXRfH57w"}}
        // this.WXInfo = test.data
        this.WXInfo = JSON.parse(localStorage.getItem('userinfo')).data
        this.type = this.$route.query.type
        // 路线列表识别
        this.RList = this.WXInfo.area === '健树' ? this.$JSRoute : this.$Route
        this.getUserInfo()
    },
    methods: {
        checkRadio (value) {
            this.Radio = value.name
            this.routeData.Route = value.name
            this.routeTitle = '路线'+value.name+':'+value.detail
            this.showRoute = false
        },
        onConfirmTime (val) {
            this.routeData.DepartTime = val
            this.showPicker = false
        },
        async onSubmit() {
            let data = {}
            let result = {}
            if (this.type === 'route') {
                data = {
                    UserId: this.WXInfo.userid,
                    Route: this.routeData.Route,
                    Destination: this.routeData.Destination,
                    Way: this.routeData.Way,
                    DepartTime: this.routeData.DepartTime,
                    Remark: this.routeData.Remark ? this.routeData.Remark : ''
                }
                result = await this.postUserRouteData(data)    
            } else {
                if (this.type === 'car') {
                    data = {
                        CarBrand: this.formData.CarBrand,
                        CarName: this.formData.CarName,
                        CarNum: this.formData.CarNum,
                        CarColor: this.formData.CarColor,
                        CarSeat: this.formData.CarSeat
                    }
                } else {
                    data = {
                        Phone: this.formData.Phone
                    }
                }
                result = await this.postUserCarData(data)
            }

            this.$toast(result.message)
            if (result.success) {
                this.$router.push({ path: '/home' })
            }
        },
        // API
        async getUserInfo() {
            const result = await this.$request({
                url: '/api/UserCar/getUserCarInfo',
                method: 'GET',
                params: {
                    // OpenId: this.WXInfo.openid
                    UserId: this.WXInfo.userid
                }
            })
            if (result.data.length > 0) {
                this.formData = result.data[0]
                const routerInfo = this.formData.routerInfo.length ? this.formData.routerInfo[0] : {}
                this.routeData = routerInfo
                this.routeTitle = '路线'+routerInfo.Route+':'+this.RList.find(value=>value.name === routerInfo.Route).detail
                this.Radio = routerInfo.Route
            } else {
                this.$toast(result.message)
            }
        },
        // 新增/更新用户基础数据
        postUserCarData(data) {
            return this.$request({
                url: this.$api.postUserCar,
                method: 'POST',
                params: {
                    UserId: this.WXInfo.userid
                },
                data: Object.assign({ UserId: this.WXInfo.userid }, data)
            })
        },
        // 新增/更新司机默认路线信息
        postUserRouteData(data) {
            return this.$request({
                url: this.$api.postUserRoute,
                method: 'POST',
                params: {
                    UserId: this.WXInfo.userid
                },
                data
            })
        }
    }
}
</script>
<style lang="less" scoped>
    .main {
        background: #FFFFFF;
        padding: 0 12px;
        min-height: 100vh;
    }
    /deep/.van-cell {
        background-color: #F5F5F5;
        margin: 8px 0;
        border-radius: 4px;
        padding: 16px 12px;
        font-size: 16px;
    }
    /deep/.van-radio__icon .van-icon {
        border: initial;
    }
    /deep/.van-stepper--round .van-stepper__plus {
        background-color: #FEB013;
    }
    /deep/.van-stepper--round .van-stepper__minus {
        color: #FFFFFF;
        background-color: #999999;
        border:initial;
    }
    .radioBox {
        display: flex;
        justify-content: space-between;
        border-radius: 4px;
        padding: 16px 12px;
        margin: 12px;
        font-size: 15px;
        font-weight: bold;
    }
</style>
